import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, CreditCard, Star, Clock } from 'lucide-react';

const TrustSignals = () => {
    const { t } = useTranslation();

    const signals = [
        {
            icon: <ShieldCheck className="w-6 h-6 text-blue-600" />,
            title: t('trust.fixed_price') || "Precio Cerrado",
            subtitle: t('trust.fixed_price_desc') || "Sin sorpresas ni cargos ocultos"
        },
        {
            icon: <CreditCard className="w-6 h-6 text-blue-600" />,
            title: t('trust.payments') || "Pagos Seguros",
            subtitle: t('trust.payments_desc') || "Visa, Mastercard, Apple Pay"
        },
        {
            icon: <Clock className="w-6 h-6 text-blue-600" />,
            title: t('trust.punctuality') || "Máxima Puntualidad",
            subtitle: t('trust.punctuality_desc') || "Conductores profesionales 24/7"
        }
    ];

    return (
        <section className="py-12 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
                    {signals.map((signal, index) => (
                        <div key={index} className="flex flex-col items-center text-center p-8 rounded-[32px] bg-slate-50 border border-slate-100 transition-all hover:shadow-xl hover:-translate-y-1">
                            <div className="w-14 h-14 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-6 border border-slate-100">
                                {signal.icon}
                            </div>
                            <h3 className="text-lg font-black text-slate-900 uppercase tracking-tight mb-2">{signal.title}</h3>
                            <p className="text-slate-500 font-medium text-sm leading-relaxed">{signal.subtitle}</p>
                        </div>
                    ))}
                </div>

                <div className="flex flex-col items-center">
                    <div className="inline-flex items-center gap-1 mb-4">
                        {[1, 2, 3, 4, 5].map((s) => (
                            <Star key={s} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                        ))}
                    </div>
                    <p className="text-xl md:text-2xl font-bold text-slate-900 text-center mb-2 italic">
                        "{t('trust.review_quote') || "Excelente servicio, el conductor fue puntual y muy amable."}"
                    </p>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center font-black text-blue-600 text-xs">JD</div>
                        <span className="text-sm font-bold text-slate-500">John D. — Google Reviews</span>
                    </div>

                    {/* Payment Logos Placeholder */}
                    <div className="mt-12 flex flex-wrap justify-center items-center gap-8 opacity-40 grayscale hover:grayscale-0 transition-all duration-500">
                        <div className="h-6 w-auto font-black text-xl italic tracking-tighter">VISA</div>
                        <div className="h-6 w-auto font-black text-xl italic tracking-tighter">mastercard</div>
                        <div className="h-6 w-auto font-black text-xl italic tracking-tighter">Apple Pay</div>
                        <div className="h-6 w-auto font-black text-xl italic tracking-tighter">G Pay</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustSignals;
